import { render } from "./Index.vue?vue&type=template&id=6bd9e59c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6bd9e59c&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=6bd9e59c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bd9e59c"

export default script